import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export const getDefaultSearchByItems = (type, translateString) => {
  const searchByItems = [
    {
      label: translateString('Code/Term'),
      value: 'TERM/CODE',
      checked: true,
    },
    {
      label: translateString('Synonym'),
      value: 'SYNONYM',
    },
    {
      label: translateString('Definition'),
      value: 'DEFINITION',
    },
    {
      label: translateString('All'),
      value: 'ALL',
    },
  ];

  if (type === 'IMDRF') {
    // remove Synonym
    searchByItems.splice(1, 1);
  }

  return searchByItems;
};

export const getMEDDRASearchByItems = (hasDefaultValue) => [
  {
    label: 'SOC',
    value: 'SOC',
    checked: !hasDefaultValue,
  },
  {
    label: 'HLGT',
    value: 'HLGT',
  },
  {
    label: 'HLT',
    value: 'HLT',
  },
  {
    label: 'PT',
    value: 'PT',
  },
  {
    label: 'LLT',
    value: 'LLT',
    checked: hasDefaultValue,
  },
];

export const getSearchOptionItems = (translateString) => [
  {
    label: translateString('All Words'),
    value: 0,
    checked: true,
  },
  {
    label: translateString('Either Word'),
    value: 1,
  },
  {
    label: translateString('Exact Phrase'),
    value: 2,
  },
];

/**
 * if
 * ex: code === ANNEX_CODE_A --> ANNEX_NAME_A
 *
 * else:
 * ex: code === ANNEX_F_CHOICE_1 --> ANNEX_F_CHOICE_NAME_1
 * ex: code === EMDV_CODES_CHOICE_4 --> EMDV_CODES_CHOICE_NAME_4
 */
export const getName = (code) => {
  if (!code) {
    return '';
  }

  if (code.includes('CODE') && !code.includes('CODES')) {
    return code.replace('CODE', 'NAME');
  } else {
    const splitCode = code.split('_');
    splitCode.splice(splitCode.length - 1, 0, 'NAME');
    return splitCode.join('_');
  }
};

export const createDataMappingList = (entityName, fieldName) => {
  const codeMapping = {
    id: uuidv4(),
    Name: fieldName,
    UpdateTo: `${entityName}.${fieldName}`,
    UpdateToType: 'xs:string',
  };

  const name = getName(fieldName);
  const nameMapping = {
    id: uuidv4(),
    Name: name,
    UpdateTo: `${entityName}.${name}`,
    UpdateToType: 'xs:string',
  };
  return [codeMapping, nameMapping];
};

export const getValueFromPath = (name, path) => {
  const index = parseInt(path.length - 1);

  return _.includes(name, 'NAME') ? path[index].Name : path[index].Code;
};
